import { Icon } from '../../../layout/Icon.jsx';

export function ToolbarFilters({ q, setQ, filter, setFilter, view, setView, counts, searching }) {
  return (
    <div className="card">
      <div className="card-b flex flex-wrap gap-2.5 items-center" style={{ padding: 12 }}>
        <div className="flex items-center gap-2 px-3 py-2 rounded-[10px] bg-white border border-line flex-1 min-w-[260px]">
          <Icon name="search" size={16} color="#9CA3AF" />
          <input
            className="border-0 outline-none flex-1 bg-transparent text-[13px]"
            placeholder="ابحث باسم الطفل أو ولي الأمر أو رقم هاتفه أو رقم الكارت..."
            value={q}
            onChange={(e) => setQ(e.target.value)}
            data-testid="active-search-input"
          />
          {searching ? <span className="text-[11px] text-ink-3">جاري البحث...</span> : null}
          {q ? (
            <button
              type="button"
              onClick={() => setQ('')}
              title="مسح البحث"
              aria-label="مسح البحث"
              data-testid="active-search-clear"
              className="text-ink-3 hover:text-ink grid place-items-center"
            >
              <Icon name="x" size={14} />
            </button>
          ) : null}
        </div>

        <div className="flex">
          {[
            { key: 'all', label: `الكل (${counts.all})` },
            { key: 'overstay', label: `تجاوز الوقت (${counts.overstay})` },
            { key: 'pending', label: `فواتير معلقة (${counts.pending})` }
          ].map((f) => (
            <button
              key={f.key}
              type="button"
              className={`btn ${filter === f.key ? 'btn-primary' : ''}`}
              style={{ padding: '6px 12px', fontSize: 12, marginInlineStart: 4 }}
              onClick={() => setFilter(f.key)}
            >
              {f.label}
            </button>
          ))}
        </div>

        <div className="flex">
          <button
            type="button"
            className={`btn ${view === 'grid' ? 'btn-primary' : ''}`}
            style={{ padding: '6px 12px', fontSize: 12, marginInlineStart: 4 }}
            onClick={() => setView('grid')}
          >
            شبكة
          </button>
          <button
            type="button"
            className={`btn ${view === 'list' ? 'btn-primary' : ''}`}
            style={{ padding: '6px 12px', fontSize: 12, marginInlineStart: 4 }}
            onClick={() => setView('list')}
          >
            قائمة
          </button>
        </div>
      </div>
    </div>
  );
}
